import React, { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom' // 👈 Switched to useSearchParams
import NavBar from '../components/NavBar/NavBar.js'
import NavPane from '../components/NavPane/NavPane.js'
import Grid from '../components/Grid/Grid.js'
import { supabase } from '../supabaseClient'

const Home = () => {
  const [videos, setVideos] = useState([])
  const [loading, setLoading] = useState(true)

  // Reads the ?search= query param directly
  const [searchParams] = useSearchParams()
  const searchQuery = searchParams.get('search') || ''

  const fetchVideos = async () => {
    setLoading(true)

    try {
      if (searchQuery.trim() !== '') {
        // 1. Fetch filtered search results matching name OR tag
        const { data, error } = await supabase
          .from('videos')
          .select('*')
          .or(`name.ilike.%${searchQuery.trim()}%,tag.ilike.%${searchQuery.trim()}%`)

        if (error) throw error
        setVideos(data || [])
      } else {
        // 2. Fetch standard feed
        const { data, error } = await supabase
          .from('videos')
          .select('*')
          .order('date', { ascending: false })

        if (error) throw error
        setVideos(data || [])
      }
    } catch (err) {
      console.error('Error fetching videos:', err)
      setVideos([])
    } finally {
      setLoading(false)
    }
  }

  // Refetches every time the searchQuery in the URL changes
  useEffect(() => {
    fetchVideos()
  }, [searchQuery])

  return (
    <div className="w-full h-full flex flex-col overflow-hidden">
      <NavBar activePage={"Home"} />
      <div className="flex pt-5 flex-row flex-1 w-full h-full overflow-hidden">
        <NavPane activePage={"Home"} />
        <div className="flex-1 p-4 overflow-y-auto">
          {loading ? (
            <div className="text-center mt-10 text-gray-500">Loading...</div>
          ) : videos.length === 0 ? (
            <div className="text-2xl font-semibold text-gray-600 w-fit relative top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
              that video dosent exist baka!! >:(
            </div>
          ) : (
            <Grid videos={videos} />
          )}
        </div>
      </div>
    </div>
  )
}

export default Home
